import { render, staticRenderFns } from "./ListItemPagination.vue?vue&type=template&id=6f95e577&scoped=true"
import script from "./ListItemPagination.vue?vue&type=script&lang=js"
export * from "./ListItemPagination.vue?vue&type=script&lang=js"
import style0 from "./ListItemPagination.vue?vue&type=style&index=0&id=6f95e577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95e577",
  null
  
)

export default component.exports